import { useCallback, useEffect, useState } from 'react'
import req from '@sportninja/common/api/request'

const useGetSuspensions = (scheduleId, routeName = 'suspensions') => {
  const [loading, setLoading] = useState(true)
  const [suspensions, setSuspensions] = useState([])

  const refresh = useCallback(async () => {
    if (scheduleId) {
      setLoading(true)
      try {
        const response = await req(`/suspensions/schedule/${scheduleId}`)
        setSuspensions(response.data)
        setLoading(false)
      } finally {
        setLoading(false)
      }
    }
  }, [scheduleId])

  useEffect(() => {
    if (window.location.pathname.includes(routeName)) {
      refresh()
    }
  }, [refresh, window.location.pathname])

  return { loading, suspensions, refresh }
}

export default useGetSuspensions
